class BookingParams {
  valid = true;

  widget;

  engine;

  code;

  triplaCode;

  checkin;

  checkout;

  roomsGuests;

  locale;

  synxisConfig;

  // eslint-disable-next-line no-undef
  baseSynXis = bookingWidget.synxis_booking_engine_url;

  // eslint-disable-next-line no-undef
  baseTripla = bookingWidget.tripla_redirect_url;

  constructor() {
    const buttons = window.document.querySelectorAll('.js-booking-widget-submit');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const { target } = event;
        this.widget = target.closest('.js-booking-widget');
        this.init();

        if (!this.validate()) {
          return;
        }

        const engineKey = (this.engine || '').trim().toLowerCase();

        if (engineKey === 'tripla') {
          this.redirectToTripla();
        } else if (engineKey === 'synxis') {
          this.redirectToSynxis();
        }
      });
    });
  }

  init() {
    this.destination();
    this.dates();
    this.rooms();
  }

  destination() {
    try {
      const engine = this.widget.querySelector('.js-destination-booking-engine').value;
      const code = this.widget.querySelector('.js-destination-hotel-code').value;
      const locale = this.widget.querySelector('.js-destination-locale').value;
      const triplaCodeEl = this.widget.querySelector('.js-destination-tripla-code');
      const synxisConfig = this.widget.querySelector('.js-destination-synxis-config');
      const synxisLevel = this.widget.querySelector('.js-destination-synxis-level');
      this.engine = engine;
      this.code = code;
      this.locale = locale;
      this.triplaCode = triplaCodeEl ? triplaCodeEl.value : '';
      this.synxisConfig = synxisConfig ? synxisConfig.value : '';
      this.synxisLevel = synxisLevel ? synxisLevel.value : '';
    } catch (exception) {
      console.error(exception);
    }
  }

  dates() {
    try {
      const { checkin } = this.widget.querySelector('.js-datepicker-checkin').dataset;
      const { checkout } = this.widget.querySelector('.js-datepicker-checkout').dataset;
      this.checkin = checkin;
      this.checkout = checkout;
    } catch (e) {
      console.error(e);
    }
  }

  rooms() {
    try {
      const rooms = this.widget.querySelectorAll('.js-rooms-room');
      const r = [];
      rooms.forEach((room) => {
        const adults = room.querySelector('.js-room-adults');
        const children = room.querySelectorAll('.js-room-age:not(.hidden)');
        const c = [];
        children.forEach((child) => {
          const age = child.querySelector('.js-room-children-age');
          c.push({
            child: age.value,
          });
        });
        if (c.length > 0) {
          r.push({ adults: adults.value, children: c });
        } else {
          r.push({ adults: adults.value });
        }
      });
      this.roomsGuests = r;
    } catch (e) {
      console.error(e);
    }
  }

  validate() {
    let isValid = true;

    // Validate Destination
    const destinationContainer = this.widget.querySelector('.bw__input-container--destination');
    if (!this.code) {
      destinationContainer.classList.add('has-error');
      isValid = false;
    } else {
      destinationContainer.classList.remove('has-error');
    }

    if (!isValid) {
      const errorContainers = this.widget?.querySelectorAll('.bw__input-container.has-error');
      errorContainers?.forEach((container) => {
        container.addEventListener('click', () => {
          container.classList.remove('has-error');
        }, { once: true });
      });
    }

    return isValid;
  }

  clearErrors() {
    const errorContainers = this.widget?.querySelectorAll('.bw__input-container.has-error');
    errorContainers?.forEach((container) => {
      container.classList.remove('has-error');
    });
  }

  synxisURL() {
    try {
      const params = new URLSearchParams();

      const setParams = (key, value) => {
        if (value !== undefined && value !== null && value !== '') {
          params.set(key, value);
        }
      };

      setParams('hotel', this.code);
      setParams('arrive', this.checkin);
      setParams('depart', this.checkout);
      setParams('locale', this.locale);
      setParams('level', this.synxisLevel);
      setParams('chain', 9542);
      setParams('clearcache', 'all');
      setParams('src', 'ohm');

      if (this.synxisConfig) {
        setParams('config', this.synxisConfig);
      }

      if (Array.isArray(this.roomsGuests) && this.roomsGuests.length > 0) {
        setParams('rooms', this.roomsGuests.length);

        const adults = this.roomsGuests
          .map((room) => room.adults ?? 0)
          .join(',');

        setParams('adult', adults);

        const childrenCounts = this.roomsGuests
          .map((room) => (room.children?.length ?? 0))
          .join(',');

        setParams('child', childrenCounts);

        const childAges = this.roomsGuests
          .map((room) => ((room.children && room.children.length > 0)
            ? room.children.map((c) => c.child).join('|')
            : ''))
          .join(',');

        setParams('childages', childAges);
      }

      return `${this.baseSynXis}/?${params.toString()}`;
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  triplaURL() {
    try {
      const params = new URLSearchParams();

      if (this.checkin) {
        params.set('checkin', this.checkin.replace(/-/g, '/'));
      }

      if (this.checkout) {
        params.set('checkout', this.checkout.replace(/-/g, '/'));
      }

      if (this.code) {
        params.set('code', this.code);
      }

      params.set('locale', this.locale);

      if (this.triplaCode) {
        params.set('hotel_id', this.triplaCode);
      }

      const rooms = this.roomsGuests.map((room) => {
        const adults = Number(room.adults || 0);

        const childrenCount = (room.children || []).length;

        return {
          adults,
          children: childrenCount,
        };
      });

      if (rooms.length > 0) {
        params.set('rooms', JSON.stringify(rooms));
      }

      return `${this.baseTripla}?${params.toString()}`;
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  redirectToTripla() {
    try {
      const triplaParams = new URL(this.triplaURL()).searchParams;
      const redirectUrl = new URL('/tripla/redirect', window.location.origin);

      triplaParams.forEach((value, key) => {
        redirectUrl.searchParams.set(key, value);
      });

      window.open(redirectUrl.toString(), '_blank');
    } catch (e) {
      console.error(e);
    }
  }

  redirectToSynxis() {
    try {
      const synxisParams = new URL(this.synxisURL()).searchParams;
      const redirectUrl = new URL('/synxis/redirect', window.location.origin);

      synxisParams.forEach((value, key) => {
        redirectUrl.searchParams.set(key, value);
      });

      window.open(redirectUrl.toString(), '_blank');
    } catch (e) {
      console.error(e);
    }
  }
}

export default BookingParams;
